export default __webpack_public_path__ + "static/media/96_desktop.b993939f.jpg";